import * as React from "react";
import styled from "styled-components";
import {transparentize} from "polished";

export interface PrepareBlockProps {
  list: string[];
}

const Container = styled.div`
  display: grid;
  gap: 14px;
`;

const Title = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0.01em;
  text-align: left;
`;

const Ol = styled.ol`
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
  
  color: ${({theme}) => `
    ${transparentize(.2, theme.variables.color)};
  `};
`;

const Li = styled.li`
  list-style-position: inside;
  padding: 0;
  
  &::before {
    content: "";
    display: inline-block;
    margin-right: 4px;
  }
`;

/**
 * The group of blocks in the task.
 * @param {PrepareBlockProps} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function PrepareBlock(
  props: PrepareBlockProps,
): React.ReactElement {

  function renderListItem(item: string) {
    return (
      <Li>{item}</Li>
    )
  }

  return (
    <Container>
      <Title>Перед тарнсляцией вам нужно:</Title>
      <Ol>
        {props.list.map(renderListItem)}
      </Ol>
    </Container>
  )
}